import common from './common'
import features from './features'

export default {
  common,
  features,
} as const
